/* =========================================================
   VOLUFILINE LANDING — page behaviour (vanilla, no dependencies, defer-safe, idempotent)

   CONFIG  <script type="application/json" id="VfConfig"> printed by sections/vf-hero:
           state (A/B/C), offerEnds (ISO or null), checkoutMode, showSub, currency, price, regular,
           cur {url, priceHtml, linesHtml, label, short}   = the hero's offer
           a   {url, priceHtml, linesHtml, label, short, ribbonHtml} = State A (full price)
   OFFER   Only the hero knows the code. Every buy block on the page is synced to it:
             [data-vf-buy]          href = state url + attributes[vf_placement] + UTM (checkout mode)
                                    ([data-vf-plan="subscribe"] links keep their own href)
             [data-vf-price]        innerHTML = priceHtml
             [data-vf-cta-label]    text = label (inside [data-vf-dock] → short)
             [data-vf-offer-lines]  innerHTML = linesHtml, hidden when empty
             [data-vf-if-a]         shown only in State A (subscribe link, rating in the dock)
             [data-vf-if-offer]     shown only with an offer (B/C)
             [data-vf-expired]      shown only after offerEnds passed (critique #21)
             [data-vf-ribbon]       swapped to the State A ribbon after expiry
           After offerEnds (visitor's clock) everything reverts to State A, checked on load and
           every 30 s. Without JS: every non-hero block shows $285 + a full-price link (safe).
   DOCK    [data-vf-dock] appears once [data-vf-dock-anchor] (under the hero CTA) is above the
           viewport; hidden while any [data-vf-hide-dock] (final band) is on screen. Sits above a
           bottom cookie bar (--vf-dock-offset); CSS lifts Gorgias while html.vf-dock-on.
   VIDEO   [data-vf-yt="<id>"] click → youtube-nocookie iframe.
   EVENTS  dataLayer.push({event, ...}) + Shopify.analytics.publish(name, data):
           volufiline_view, volufiline_buy_click {placement, plan}, volufiline_video_play
           {placement, video_id}, volufiline_faq_open {q}, volufiline_fold_open {fold},
           volufiline_click {what} for [data-vf-track="what"].
   ========================================================= */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  var cfg = {};
  try { cfg = JSON.parse((d.getElementById('VfConfig') || {}).textContent || '{}'); } catch (e) {}

  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function once(el, key) { var k = 'data-vf-b-' + key; if (el.hasAttribute(k)) return false; el.setAttribute(k, ''); return true; }

  /* ---------- UTM (kept for the tab, passed to checkout) ---------- */
  var utm = {};
  try { utm = JSON.parse(sessionStorage.getItem('vf_utm') || '{}'); } catch (e) {}
  try {
    var qs = new URLSearchParams(location.search), fresh = {}, got = false;
    qs.forEach(function (v, k) { if (/^utm_/.test(k)) { fresh[k] = v; got = true; } });
    if (got) { utm = fresh; sessionStorage.setItem('vf_utm', JSON.stringify(utm)); }
  } catch (e) {}

  /* ---------- offer state ---------- */
  function isExpired() {
    if (cfg.expired) return true; /* Liquid already saw the end date pass (state printed as A) */
    if (!cfg.offerEnds || cfg.state === 'A') return false;
    var t = Date.parse(cfg.offerEnds);
    return !isNaN(t) && Date.now() > t;
  }
  var expired = isExpired();
  function eff() { return (expired || !cfg.cur) ? (cfg.a || {}) : cfg.cur; }
  function effState() { return expired ? 'A' : (cfg.state || 'A'); }

  function track(name, data) {
    data = Object.assign({ page: 'volufiline', offer_state: effState() }, utm, data || {});
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) {}
  }

  function buyHref(base, placement) {
    if (!base) return null;
    if (cfg.checkoutMode && /^\/cart\/\d/.test(base)) {
      var p = ['attributes[vf_placement]=' + encodeURIComponent(placement)];
      Object.keys(utm).forEach(function (k) { p.push(encodeURIComponent(k) + '=' + encodeURIComponent(utm[k])); });
      return base + (base.indexOf('?') > -1 ? '&' : '?') + p.join('&');
    }
    return base;
  }

  /* Cart mode: add the jar with /cart/add.js, tag the cart (vf_source / vf_placement / UTM) and
     open /cart (through /discount/CODE while the video price is on). Any failure: follow the href,
     which does the same without JS (/cart/add?…&return_to=/cart). */
  function cartAdd(a, pl, plan, e) {
    if (cfg.buyMode !== 'cart' || !window.fetch || a.hasAttribute('data-vf-soldout')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    if (a.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }
    var vid = cfg.variantId;
    if (!vid) return;
    e.preventDefault();
    a.setAttribute('aria-busy', 'true');
    var item = { id: vid, quantity: 1 };
    if (plan === 'subscribe') item.selling_plan = Number(a.getAttribute('data-vf-plan-id')) || undefined;
    var items = [item];
    if (cfg.giftId) items.push({ id: cfg.giftId, quantity: 1, properties: { _vf_gift: 'volufiline-lp' } });
    var attrs = { vf_source: 'volufiline-lp', vf_placement: pl };
    Object.keys(utm).forEach(function (k) { attrs['vf_' + k] = utm[k]; });
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var go = (!expired && cfg.code && plan !== 'subscribe' && !(cfg.giftId && cfg.giftCode)) ? root + 'discount/' + encodeURIComponent(cfg.code) + '?redirect=' + encodeURIComponent(root + 'cart') : root + 'cart';
    var href = a.getAttribute('href');
    var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    fetch(root + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items }), credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); })
      .then(function () {
        var upd = { attributes: attrs };
        /* gift: apply the offer code and the gift code together on the cart (comma-separated) */
        if (cfg.giftId && cfg.giftCode) {
          var codes = [cfg.giftCode];
          if (!expired && cfg.code && plan !== 'subscribe') codes.unshift(cfg.code);
          upd.discount = codes.join(',');
        }
        return fetch(root + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify(upd), credentials: 'same-origin' }).catch(function () {});
      })
      .then(function () {
        /* open the theme cart drawer (cart apps hook into it) instead of leaving for /cart */
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || go !== root + 'cart') { location.href = go; return; }
        return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          var de = document.documentElement;
          de.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          de.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
          a.removeAttribute('aria-busy');
        });
      }, function () { location.href = href; })
      .catch(function () { location.href = root + 'cart'; });
  }

  function applyOfferBase() {
    var s = eff(), st = effState();
    $$('[data-vf-buy]').forEach(function (a) {
      var pl = a.getAttribute('data-vf-buy') || 'page';
      var plan = a.getAttribute('data-vf-plan') || 'one-time';
      if (plan === 'one-time' && !a.hasAttribute('data-vf-soldout') && !a.hasAttribute('data-vf-sel-btn')) {
        var h = buyHref(s.url, pl);
        if (h) a.setAttribute('href', h);
      }
      if (once(a, 'buy')) a.addEventListener('click', function (e) {
        var p = a.getAttribute('data-vf-plan') || 'one-time'; /* read at click time: the plan picker changes it */
        track('volufiline_buy_click', { placement: pl, plan: p, value: p === 'subscribe' ? null : (expired ? cfg.regular : cfg.price) || null, currency: cfg.currency || 'USD' });
        cartAdd(a, pl, p, e);
      });
    });
    /* links to the product page's reviews keep the video price (State B/C) */
    $$('[data-vf-pdp-link]').forEach(function (a) {
      if (!a.__vfPdp) a.__vfPdp = a.getAttribute('href');
      var base = a.__vfPdp, hash = '';
      if (base.indexOf('#') > -1) { hash = base.slice(base.indexOf('#')); base = base.slice(0, base.indexOf('#')); }
      a.setAttribute('href', (st !== 'A' && cfg.code) ? '/discount/' + encodeURIComponent(cfg.code) + '?redirect=' + encodeURIComponent(base) + hash : a.__vfPdp);
    });
    if (!cfg.cur) return;
    $$('[data-vf-price]').forEach(function (el) { if (s.priceHtml) el.innerHTML = s.priceHtml; });
    $$('[data-vf-cta-label]').forEach(function (el) {
      var t = el.closest('[data-vf-dock]') ? s.short : s.label;
      if (t && !el.closest('[data-vf-soldout]')) el.textContent = t;
    });
    $$('[data-vf-offer-lines]').forEach(function (el) { el.innerHTML = s.linesHtml || ''; el.hidden = !s.linesHtml; });
    $$('[data-vf-if-a]').forEach(function (el) { el.hidden = st !== 'A' || (el.classList.contains('vf-sub') && !cfg.showSub); });
    $$('[data-vf-if-offer]').forEach(function (el) { el.hidden = st === 'A'; });
    $$('[data-vf-expired]').forEach(function (el) { el.hidden = !expired; });
    if (expired && cfg.a && cfg.a.ribbonHtml) $$('[data-vf-ribbon]').forEach(function (el) { el.innerHTML = cfg.a.ribbonHtml; });
  }
  function applyOffer() { applyOfferBase(); syncPlans(); }

  /* ---------- plan picker (hero + closing band): subscribe-first ----------
     Radios [data-vf-plan-opt] carry href / label / short / price. The picked plan drives the button in
     the same .vf-buy ([data-vf-sel-btn]), the dock button + price and the story-viewer button. All
     pickers on the page stay in sync. Only in State A (pickers are [data-vf-if-a]). */
  var curPlan = null;
  function planOpt(v) {
    var r = d.querySelector('[data-vf-plans] input[value="' + v + '"]');
    return r ? r : null;
  }
  function setBtn(btn, opt, short) {
    if (!btn || !opt) return;
    var sub = opt.value === 'subscribe';
    var h = opt.getAttribute('data-href');
    if (!sub) h = buyHref(h, btn.getAttribute('data-vf-buy') || 'page');
    if (h) btn.setAttribute('href', h);
    if (sub) { btn.setAttribute('data-vf-plan', 'subscribe'); btn.setAttribute('data-vf-plan-id', opt.getAttribute('data-plan-id') || ''); }
    else { btn.removeAttribute('data-vf-plan'); btn.removeAttribute('data-vf-plan-id'); }
    var lab = btn.querySelector('[data-vf-cta-label]');
    if (lab) lab.textContent = opt.getAttribute(short ? 'data-short' : 'data-label') || lab.textContent;
  }
  function syncPlans() {
    var opts = $$('[data-vf-plans] input[data-vf-plan-opt]');
    if (!opts.length || effState() !== 'A') return;
    if (!curPlan) {
      var c = opts.filter(function (o) { return o.checked; })[0];
      curPlan = cfg.defaultPlan || (c ? c.value : 'subscribe');
    }
    var pick = planOpt(curPlan) || opts[0];
    curPlan = pick.value;
    opts.forEach(function (o) {
      o.checked = o.value === curPlan;
      var l = o.closest('.vf-plan');
      if (l) l.classList.toggle('is-on', o.checked);
    });
    /* every buy button on the page follows the picked plan (pickers, inline buttons, dock, story) */
    var narrow = window.innerWidth < 420;
    $$('[data-vf-buy]').forEach(function (btn) {
      if (btn.hasAttribute('data-vf-soldout') || btn.classList.contains('vf-sub__link')) return;
      var inDock = !!btn.closest('[data-vf-dock]');
      setBtn(btn, pick, inDock && narrow);
    });
    var dp = d.querySelector('[data-vf-dock] [data-vf-price]');
    if (dp) dp.innerHTML = curPlan === 'subscribe'
      ? '<s class="vf-price__was"><span class="vf-vh">Regular price </span>' + pick.getAttribute('data-was') + '</s><span class="vf-price__now">' + pick.getAttribute('data-price') + '</span>'
      : '<span class="vf-price__now">' + pick.getAttribute('data-price') + '</span>';
  }
  function bindPlans() {
    $$('[data-vf-plans] input[data-vf-plan-opt]').forEach(function (o) {
      if (!once(o, 'plan')) return;
      o.addEventListener('change', function () {
        if (!o.checked) return;
        curPlan = o.value; syncPlans();
        track('volufiline_plan_select', { plan: curPlan, placement: ((o.closest('.vf-buy') || {}).querySelector ? (o.closest('.vf-buy').querySelector('[data-vf-buy]') || {}).getAttribute('data-vf-buy') : '') });
      });
    });
  }

  /* ---------- hero gallery: scroll-snap track + arrows + thumbnails ---------- */
  function bindGal() {
    $$('[data-vf-gal]').forEach(function (g) {
      if (!once(g, 'gal')) return;
      var tr = g.querySelector('[data-vf-gal-track]');
      if (!tr) return;
      var slides = $$('.vf-gal__slide', tr), thumbs = $$('[data-vf-gal-go]', g);
      var prev = g.querySelector('[data-vf-gal-prev]'), next = g.querySelector('[data-vf-gal-next]');
      var cur = 0;
      function idx() { var w = tr.clientWidth || 1; return Math.max(0, Math.min(slides.length - 1, Math.round(tr.scrollLeft / w))); }
      function mark(i) {
        cur = i;
        thumbs.forEach(function (t, n) { if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
      }
      function go(i, smooth) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        tr.scrollTo({ left: i * tr.clientWidth, behavior: (smooth === false || reduce) ? 'auto' : 'smooth' });
        mark(i);
      }
      var t = null;
      tr.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { var i = idx(); if (i !== cur) { mark(i); track('volufiline_gallery', { slide: i + 1 }); } }, 90); }, { passive: true });
      thumbs.forEach(function (b) { b.addEventListener('click', function () { go(Number(b.getAttribute('data-vf-gal-go')) || 0); }); });
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      tr.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      });
      window.addEventListener('resize', function () { go(cur, false); });
      mark(0);
    });
  }

  /* ---------- creator tile: muted loop, only after load + in view; never with reduced motion / save-data ---------- */
  function startTile() {
    var v = d.querySelector('[data-vf-tile]');
    if (!v || v.__vfTile) return;
    v.__vfTile = true;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var save = navigator.connection && navigator.connection.saveData;
    if (reduce || save || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting && !html.classList.contains('vf-story-open')) {
          if (!v.getAttribute('src')) { v.src = v.getAttribute('data-src'); }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { v.pause(); }
      });
    }, { threshold: 0.4 });
    io.observe(v);
  }

  /* ---------- story viewer (creator clips, with sound) ---------- */
  var story = null;
  function bindStory() {
    var roots = $$('[data-vf-story]');
    var root = roots[0];
    if (!root || root.__vfStory) return;
    roots.slice(1).forEach(function (r) { r.parentNode.removeChild(r); }); /* one viewer per page */
    root.__vfStory = true;
    if (root.parentNode !== d.body) d.body.appendChild(root); /* escape section stacking contexts */
    var list = [];
    try { list = JSON.parse((root.querySelector('[data-vf-stories]') || {}).textContent || '[]'); } catch (e) {}
    list = list.filter(function (c) { return c && c.src; });
    if (!list.length) return;
    var vid = root.querySelector('[data-vf-story-vid]'), bars = root.querySelector('[data-vf-story-bars]');
    var q = root.querySelector('[data-vf-story-q]'), nm = root.querySelector('[data-vf-story-name]');
    var tog = root.querySelector('[data-vf-story-toggle]');
    var opener = null, i = 0;
    bars.innerHTML = list.map(function () { return '<span><i></i></span>'; }).join('');
    var fills = $$('i', bars);
    function load(n) {
      i = (n + list.length) % list.length;
      var c = list[i];
      fills.forEach(function (f, k) { f.style.width = k < i ? '100%' : '0'; });
      vid.poster = c.poster || '';
      vid.src = c.src;
      q.textContent = c.quote || '';
      nm.textContent = c.name || '';
      root.setAttribute('aria-label', (c.name ? c.name + ', ' : '') + 'creator video ' + (i + 1) + ' of ' + list.length);
      resume();
      track('volufiline_video_play', { placement: 'story', video_id: c.name || String(i + 1) });
    }
    function resume() { var p = vid.play(); if (p && p.catch) p.catch(function () { root.classList.add('is-paused'); }); root.classList.remove('is-paused'); if (tog) tog.setAttribute('aria-label', 'Pause'); }
    function pause() { vid.pause(); root.classList.add('is-paused'); if (tog) tog.setAttribute('aria-label', 'Play'); }
    function open(n, from) {
      opener = from || d.activeElement;
      root.hidden = false;
      html.classList.add('vf-story-open');
      var tv = d.querySelector('[data-vf-tile]'); if (tv) tv.pause();
      load(n || 0);
      var c = root.querySelector('[data-vf-story-close]'); if (c) c.focus({ preventScroll: true });
      track('volufiline_click', { what: 'story_open' });
    }
    function close() {
      vid.pause(); vid.removeAttribute('src'); vid.load();
      root.hidden = true;
      html.classList.remove('vf-story-open');
      var tv = d.querySelector('[data-vf-tile]');
      if (tv && tv.getAttribute('src') && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) { var p = tv.play(); if (p && p.catch) p.catch(function () {}); }
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }
    function step(dir) { if (dir > 0 && i === list.length - 1) { close(); return; } load(i + dir); }
    story = { open: open, close: close };
    vid.addEventListener('timeupdate', function () { if (vid.duration) fills[i].style.width = Math.min(100, vid.currentTime / vid.duration * 100) + '%'; });
    vid.addEventListener('ended', function () { step(1); });
    $$('[data-vf-story-next]', root).forEach(function (b) { b.addEventListener('click', function () { step(1); }); });
    $$('[data-vf-story-prev]', root).forEach(function (b) { b.addEventListener('click', function () { if (vid.currentTime > 2) { vid.currentTime = 0; resume(); } else load(i - 1); }); });
    if (tog) tog.addEventListener('click', function () { if (vid.paused) resume(); else pause(); });
    root.querySelector('[data-vf-story-close]').addEventListener('click', close);
    root.addEventListener('click', function (e) { if (e.target === root) close(); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'ArrowRight') { step(1); return; }
      if (e.key === 'ArrowLeft') { load(i - 1); return; }
      if (e.key === 'Tab') {
        var f = $$('button, a[href]', root).filter(function (el) { return el.offsetParent !== null && el.tabIndex !== -1; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    var sx = null, sy = null;
    root.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      sx = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) step(1); else load(i - 1); }
      else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close();
    }, { passive: true });
    $$('[data-vf-story-open]').forEach(function (b) {
      b.addEventListener('click', function () { open(Number(b.getAttribute('data-vf-story-open')) || 0, b); });
    });
  }

  /* ---------- card carousel (reviews): scroll-snap track + arrows + "n / N" counter ---------- */
  function bindCar() {
    $$('[data-vf-car]').forEach(function (c) {
      if (!once(c, 'car')) return;
      var tr = c.querySelector('[data-vf-car-track]');
      if (!tr) return;
      var items = $$(':scope > li', tr), pos = c.querySelector('[data-vf-car-pos]');
      var prev = c.querySelector('[data-vf-car-prev]'), next = c.querySelector('[data-vf-car-next]');
      function step() {
        var g = parseFloat(getComputedStyle(tr).columnGap) || 0;
        return items[0] ? items[0].getBoundingClientRect().width + g : tr.clientWidth;
      }
      var raf = 0;
      function upd() {
        raf = 0;
        var i = Math.round(tr.scrollLeft / (step() || 1));
        if (pos) pos.textContent = Math.min(items.length, i + 1);
        if (prev) prev.disabled = tr.scrollLeft <= 2;
        if (next) next.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 2;
      }
      function go(dir) {
        var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        tr.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
        track('volufiline_click', { what: dir > 0 ? 'reviews_next' : 'reviews_prev' });
      }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      tr.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      });
      tr.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(upd); });
      upd();
    });
  }

  /* ---------- scroll reveal: fade-up once, below-the-fold only, never with reduced motion ---------- */
  function bindReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = $$('.vf-sec .vf-head, .vf-rv2__side, .vf-rv2__car, .vf-video__clip, .vf-how__step, .vf-why__tile, .vf-faq .vf-fold, .vf-doctor__grid > *, .vf-final__grid > *, [data-vf-reveal]');
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el, n) {
      if (el.__vfRv || el.getBoundingClientRect().top < vh) return;
      el.__vfRv = true;
      el.classList.add('vf-rv');
      el.style.transitionDelay = ((n % 3) * 70) + 'ms';
      io.observe(el);
    });
  }

  function watchExpiry() {
    if (!cfg.offerEnds || expired) return;
    var timer = setInterval(function () {
      if (isExpired()) { expired = true; clearInterval(timer); applyOffer(); }
    }, 30000);
  }

  /* ---------- bottom buy dock ---------- */
  var dock = null, anchor = null;
  function inView(el, frac) {
    var r = el.getBoundingClientRect(), vh = window.innerHeight;
    var vis = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    return vis > 0 && vis >= Math.min(r.height, vh) * frac;
  }
  function setShown(on) {
    if (!dock || dock.classList.contains('is-on') === on) return;
    dock.classList.toggle('is-on', on);
    dock.setAttribute('aria-hidden', on ? 'false' : 'true');
    $$('a, button', dock).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
    html.classList.toggle('vf-dock-on', on);
  }
  /* Shown whenever the hero buy button is off screen (scrolled past, or below the fold on a short
     phone), except while another inline buy button is at least half in view, and from the moment
     the closing band comes up until the end of the page (never over the footer). */
  function updateDock() {
    if (!dock || !anchor) return;
    var vh = window.innerHeight;
    var heroBtn = anchor.parentNode && anchor.parentNode.querySelector('[data-vf-buy]');
    var hb = (heroBtn || anchor).getBoundingClientRect();
    /* phones: also while the hero button is still below the fold; bigger screens only once it has scrolled past */
    var heroOff = hb.bottom < 0 || (window.innerWidth < 750 && hb.top > vh - (dock.offsetHeight || 66));
    var other = $$('.vf-buy [data-vf-buy]').some(function (b) {
      return b !== heroBtn && !b.closest('[data-vf-dock]') && b.offsetParent !== null && inView(b, 0.5);
    });
    var stop = $$('[data-vf-hide-dock]').some(function (el) { return el.getBoundingClientRect().top < vh * 0.85; });
    setShown(heroOff && !other && !stop && !html.classList.contains('vf-consent-tall'));
    /* the Gorgias bubble waits until the hero buy button has scrolled away (it sat on the hero photo / buy card) */
    html.classList.toggle('vf-hero-zone', anchor.getBoundingClientRect().bottom > 0);
  }
  /* Cookie bars fixed to the bottom (theme app #cb-cookie_consent or Shopify's banner): keep the
     dock above whichever is showing. offsetParent is null for fixed elements, so measure boxes. */
  var COVERS = '#cb-cookie_consent .cb-cookie_consent-container, #shopify-pc__banner';
  var lastOff = -1;
  function bannerOffset() {
    var vh = window.innerHeight, off = 0;
    $$(COVERS).forEach(function (b) {
      var cs = getComputedStyle(b);
      if (cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = b.getBoundingClientRect();
      if (r.height > 0 && r.top < vh && r.bottom > vh - 4) off = Math.max(off, Math.round(vh - r.top));
    });
    /* a tall consent sheet (more than 120px) is not lifted over: the dock waits until it closes */
    html.classList.toggle('vf-consent-tall', off > 120);
    if (off > 120) off = 0;
    if (off === lastOff) return;
    lastOff = off;
    html.style.setProperty('--vf-dock-offset', off + 'px');
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; updateDock(); });
  }

  /* ---------- video facade ---------- */
  function play(btn) {
    var id = btn.getAttribute('data-vf-yt');
    if (!id) return;
    var f = d.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1&modestbranding=1';
    f.title = btn.getAttribute('data-title') || 'Video';
    f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    f.setAttribute('allowfullscreen', '');
    f.className = 'vf-yt vf-yt--on';
    btn.replaceWith(f);
    track('volufiline_video_play', { placement: btn.getAttribute('data-vf-yt-place') || '', video_id: id });
  }

  /* ---------- binds (re-run on theme-editor section reloads) ---------- */
  function bind() {
    bindGal(); bindPlans(); bindStory(); bindCar();
    $$('[data-vf-yt]').forEach(function (b) { if (once(b, 'yt')) b.addEventListener('click', function () { play(b); }); });
    $$('details.vf-faq__item, details[data-vf-faq]').forEach(function (det) {
      if (!once(det, 'faq')) return;
      det.addEventListener('toggle', function () { if (det.open) track('volufiline_faq_open', { q: ((det.querySelector('summary') || {}).textContent || '').trim().slice(0, 120) }); });
    });
    $$('details[data-vf-fold]').forEach(function (det) {
      if (!once(det, 'fold')) return;
      det.addEventListener('toggle', function () { if (det.open) track('volufiline_fold_open', { fold: det.getAttribute('data-vf-fold') }); });
    });
    $$('[data-vf-track]').forEach(function (a) {
      if (!once(a, 'trk')) return;
      a.addEventListener('click', function () { track('volufiline_click', { what: a.getAttribute('data-vf-track') }); });
    });
  }

  function init() {
    try { cfg = JSON.parse((d.getElementById('VfConfig') || {}).textContent || '{}'); } catch (e) {}
    expired = isExpired();
    dock = d.querySelector('[data-vf-dock]');
    anchor = d.querySelector('[data-vf-dock-anchor]');
    applyOffer(); bind(); bannerOffset(); updateDock();
  }
  /* Gorgias: switch its timed campaigns / engagement pill off on this page through its own API
     (CSS hides them too, but only the API also resets the launcher's open "X" state). */
  function quietChat() {
    var n = 0;
    (function t() {
      var G = window.GorgiasChat;
      if (G && typeof G.init === 'function') {
        try { var p = G.init(); if (p && p.then) p.then(function () { try { if (typeof G.disableChatCampaigns === 'function') G.disableChatCampaigns(); } catch (e) {} }, function () {}); } catch (e) {}
        return;
      }
      if (++n < 60) setTimeout(t, 500);
    })();
  }
  var booted = false;
  function boot() {
    if (booted) return;
    booted = true;
    init(); watchExpiry(); quietChat();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { bannerOffset(); updateDock(); syncPlans(); });
    d.addEventListener('click', function () { setTimeout(bannerOffset, 400); }, true);
    [800, 1500, 3000, 6000].forEach(function (t) { setTimeout(bannerOffset, t); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { $$('[aria-busy="true"][data-vf-buy]').forEach(function (a) { a.removeAttribute('aria-busy'); }); bannerOffset(); updateDock(); } });
    var go = function () { bindReveal(); (window.requestIdleCallback || function (f) { return setTimeout(f, 300); })(startTile); };
    if (d.readyState === 'complete') go(); else window.addEventListener('load', go);
    track('volufiline_view', { viewport: window.innerWidth >= 1024 ? 'd' : window.innerWidth >= 750 ? 't' : 'm', expired: expired });
  }
  if (window.__vfLanding) return;
  window.__vfLanding = true;
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', init);
})();


/* #########################################################
   MODULE: vf-reviews  (sections/vf-reviews.liquid)
   ######################################################### */
/* =========================================================
   VOLUFILINE — reviews (sections/vf-reviews.liquid)
   1. Rail progress bar on phones (scroll-snap card rail).
   2. Live star bars: when the section nears the viewport, read Okendo's public review totals
      (api.okendo.io …/review_aggregate, CORS *) and refresh the 5 bars, the count and % recommend.
      On any failure the Liquid numbers (metafield + settings) stay.
   3. "Read all N reviews": without JS a link to the PDP's Okendo widget. With JS it opens a panel
      and mounts Okendo's own widget there on first tap (no Okendo widget bytes before the tap).
      Uses window.okeWidgetApi.initWidget once okendo-reviews.js (app embed, async) is ready.
   Events: volufiline_click {what: reviews_all} comes from data-vf-track (vf-landing.js);
   this file adds volufiline_reviews_open {loaded} once the widget renders.
   ========================================================= */
(function () {
  'use strict';
  if (window.__vfReviews) return; /* vf-landing.js is included by every vf section; run once */
  window.__vfReviews = true;

  function push(name, data) {
    data = Object.assign({ page: 'volufiline' }, data || {});
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) {}
  }

  function subscriberId(root) {
    try {
      var s = document.getElementById('oke-reviews-settings');
      if (s) { var j = JSON.parse(s.textContent); if (j && j.subscriberId) return j.subscriberId; }
    } catch (e) {}
    return root.getAttribute('data-oke-sub') || '';
  }

  /* 1. rail progress */
  function initRail(root) {
    var track = root.querySelector('[data-vf-rev-track]');
    var bar = root.querySelector('[data-vf-rev-progress]');
    if (!track || !bar) return;
    var raf = 0;
    function update() {
      raf = 0;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 1) { bar.parentNode.style.visibility = 'hidden'; return; }
      bar.parentNode.style.visibility = '';
      var frac = track.clientWidth / track.scrollWidth;
      bar.style.width = (frac * 100) + '%';
      var p = Math.min(1, Math.max(0, track.scrollLeft / max));
      bar.style.transform = 'translateX(' + (p * (1 / frac - 1) * 100) + '%)';
    }
    track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(update); });
    update();
  }

  /* 2. live star bars */
  function initLive(root) {
    if (!root.hasAttribute('data-live-hist') || !window.fetch) return;
    var id = root.getAttribute('data-oke-id');
    var sub = subscriberId(root);
    if (!id || !sub) return;
    var done = false;
    function load() {
      if (done) return; done = true;
      fetch('https://api.okendo.io/v1/stores/' + encodeURIComponent(sub) + '/products/' + encodeURIComponent(id) + '/review_aggregate', { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var a = j && j.reviewAggregate;
          if (!a) return;
          var lv = a.reviewCountByLevel || a.ratingAndReviewCountByLevel || {};
          var total = a.reviewCount || 0;
          if (total < 1) return;
          root.querySelectorAll('[data-vf-rev-hist] li[data-level]').forEach(function (li) {
            var n = li.getAttribute('data-level');
            var c = lv['level' + n + 'Count'] || 0;
            var num = li.querySelector('[data-vf-rev-n]'); if (num) num.textContent = c;
            var i = li.querySelector('.vf-reviews__bar i'); if (i) i.style.width = (Math.round(c * 1000 / total) / 10) + '%';
          });
          root.querySelectorAll('[data-vf-rev-count]').forEach(function (el) { el.textContent = total; });
          var lbl = root.querySelector('[data-vf-rev-all-label]');
          if (lbl) lbl.textContent = lbl.textContent.replace(/\d+/, total);
          var rec = root.querySelector('[data-vf-rev-rec]');
          if (rec && typeof a.recommendationCount === 'number') {
            var pct = Math.round(a.recommendationCount * 100 / total);
            rec.textContent = rec.textContent.replace(/\d+%/, pct + '%');
          }
          if (a.reviewRatingValuesTotal) {
            var avg = (Math.round(a.reviewRatingValuesTotal * 10 / total) / 10).toFixed(1);
            root.querySelectorAll('[data-vf-rev-avg]').forEach(function (el) { el.textContent = avg; });
          }
        })
        .catch(function () {});
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else { load(); }
  }

  /* 3. full Okendo widget on tap */
  function initAll(root) {
    var more = root.querySelector('[data-vf-rev-more]');
    var panel = more && document.getElementById(more.getAttribute('aria-controls'));
    if (!panel) return;
    var slot = panel.querySelector('[data-vf-rev-slot]');
    var less = panel.querySelector('[data-vf-rev-less]');
    var fb = panel.querySelector('[data-vf-rev-fallback]');
    if (!slot) return;
    var id = root.getAttribute('data-oke-id');
    var mounted = false;
    more.setAttribute('role', 'button');
    more.setAttribute('aria-expanded', 'false');

    function rendered(el) { return el.childElementCount > 0; }

    function mount() {
      if (mounted) return; mounted = true;
      var el = document.createElement('div');
      el.setAttribute('data-oke-widget', '');
      el.setAttribute('data-oke-reviews-product-id', id);
      slot.classList.add('is-loading');
      slot.appendChild(el);
      var tries = 0, called = false;
      /* If Okendo's script is still loading, its own start-up scan will find this element; only
         call initWidget ourselves if the API was already there, or ~2 s after it appears. */
      var apiReady = !!(window.okeWidgetApi && window.okeWidgetApi.initWidget);
      var seenAt = apiReady ? 0 : -1;
      (function wait() {
        if (rendered(el)) { finish(true); return; }
        var api = window.okeWidgetApi;
        if (api && seenAt < 0) seenAt = tries;
        if (!called && api && typeof api.initWidget === 'function' && (apiReady || tries - seenAt >= 10)) {
          called = true;
          try { var p = api.initWidget(el); if (p && p.then) p.then(function () {}, function () {}); } catch (e) {}
        }
        if (++tries > 60) { finish(false); return; } /* ~12 s */
        setTimeout(wait, 200);
      })();
      function finish(ok) {
        slot.classList.remove('is-loading');
        if (!ok && fb) { fb.hidden = false; slot.hidden = true; }
        push('volufiline_reviews_open', { loaded: ok });
      }
    }

    /* full-screen sheet: close button + Esc, page scroll locked, focus kept inside */
    if (panel.parentNode !== document.body) document.body.appendChild(panel);
    function setOpen(open) {
      panel.hidden = !open;
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('vf-sheet-open', open);
      if (open) { mount(); if (less) less.focus({ preventScroll: true }); }
      else more.focus({ preventScroll: true });
    }
    more.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      setOpen(true);
    });
    more.addEventListener('keydown', function (e) {
      if (e.key === ' ') { e.preventDefault(); more.click(); }
    });
    if (less) less.addEventListener('click', function () { setOpen(false); });
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); setOpen(false); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.slice.call(panel.querySelectorAll('button, a[href], [tabindex="0"]')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    /* phones: three reviews stacked, the rest behind "Show more reviews" */
    var showMore = root.querySelector('[data-vf-rev-showmore]');
    if (showMore) showMore.addEventListener('click', function () {
      root.classList.add('is-all');
      showMore.hidden = true;
      push('volufiline_click', { what: 'reviews_more' });
    });
  }

  function init() {
    document.querySelectorAll('[data-vf-reviews]').forEach(function (root) {
      if (root.__vfRev) return; root.__vfRev = true;
      initRail(root); initLive(root); initAll(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();


/* #########################################################
   MODULE: vf-video  (sections/vf-video.liquid)
   ######################################################### */
/* Volufiline: video section.
   - [data-vf-clip] frames: no bytes before tap (src lives in data-src), tap toggles play/pause.
   - Creator clips play WITH sound, only between data-start and data-end (the full CDN files carry
     claims outside the approved segment). Clamped by rAF while playing + timeupdate + seeking.
     When the end is reached the clip pauses and rewinds to its start.
   - Only one video plays at a time (also pauses when Dr. Rajani's YouTube facade is tapped,
     or when the tab is hidden).
   - Event: volufiline_video_play {placement: 'video-howto' | 'video-creator', video_id}. */
(function () {
  'use strict';
  if (window.__vfVideo) return; /* vf-landing.js is included by every vf section; run once */
  window.__vfVideo = true;
  var d = document;

  function track(name, data) {
    data = Object.assign({ page: 'volufiline' }, data || {});
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) {}
  }

  var frames = [];
  function pauseOthers(except) {
    frames.forEach(function (f) { if (f !== except) stop(f, false); });
  }

  function bounds(f) {
    var s = parseFloat(f.getAttribute('data-start')) || 0;
    var e = parseFloat(f.getAttribute('data-end'));
    return { s: s, e: (isFinite(e) && e > s) ? e : Infinity };
  }

  function setUi(f, playing) {
    f.classList.toggle('is-playing', playing);
    var btn = f.querySelector('.vf-video__toggle');
    if (btn) {
      btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      var lbl = btn.getAttribute('aria-label') || '';
      if (!btn.__vfLbl) btn.__vfLbl = lbl;
      btn.setAttribute('aria-label', playing ? btn.__vfLbl.replace(/^Play\b/, 'Pause') : btn.__vfLbl);
    }
  }

  function progress(f, v) {
    var fill = f.querySelector('.vf-video__bar-fill');
    if (!fill) return;
    var b = bounds(f), len = (b.e === Infinity ? (v.duration || 0) : b.e) - b.s;
    var p = len > 0 ? Math.min(1, Math.max(0, (v.currentTime - b.s) / len)) : 0;
    fill.style.transform = 'scaleX(' + p + ')';
  }

  function guard(f, v) {
    var b = bounds(f);
    if (v.currentTime >= b.e - 0.04) { stop(f, true); return false; }
    if (v.currentTime < b.s - 0.3) { try { v.currentTime = b.s; } catch (e) {} }
    return true;
  }

  function loop(f, v) {
    if (v.paused || v.ended) return;
    if (!guard(f, v)) return;
    progress(f, v);
    f._raf = requestAnimationFrame(function () { loop(f, v); });
  }

  function stop(f, rewind) {
    var v = f.querySelector('video');
    if (!v) return;
    if (!v.paused) v.pause();
    if (f._raf) cancelAnimationFrame(f._raf);
    if (rewind) {
      var b = bounds(f);
      try { v.currentTime = b.s; } catch (e) {}
      f.classList.remove('is-started');
      progress(f, v);
    }
    setUi(f, false);
  }

  function start(f) {
    var v = f.querySelector('video');
    if (!v) return;
    var creator = f.getAttribute('data-kind') === 'creator';
    var b = bounds(f);
    if (!v.getAttribute('src')) {
      v.setAttribute('src', f.getAttribute('data-src'));
      v.preload = 'auto';
      if (creator) {
        v.addEventListener('loadedmetadata', function () { if (v.currentTime < b.s - 0.3 || v.currentTime >= b.e) { try { v.currentTime = b.s; } catch (e) {} } });
        v.addEventListener('timeupdate', function () { guard(f, v); progress(f, v); });
        v.addEventListener('seeking', function () { var bb = bounds(f); if (v.currentTime >= bb.e || v.currentTime < bb.s - 0.3) { try { v.currentTime = bb.s; } catch (e) {} } });
        v.addEventListener('ended', function () { stop(f, true); });
      }
      v.addEventListener('pause', function () { setUi(f, false); });
      v.addEventListener('play', function () { setUi(f, true); });
      track('volufiline_video_play', { placement: creator ? 'video-creator' : 'video-howto', video_id: f.getAttribute('data-id') || '' });
    }
    if (creator) {
      v.muted = false;
      if (v.readyState >= 1 && (v.currentTime < b.s - 0.3 || v.currentTime >= b.e - 0.04)) { try { v.currentTime = b.s; } catch (e) {} }
    } else {
      v.muted = true;
    }
    pauseOthers(f);
    f.classList.add('is-started');
    setUi(f, true);
    var p = v.play();
    if (p && typeof p.then === 'function') {
      p.then(function () { loop(f, v); }, function () { setUi(f, false); });
    } else { loop(f, v); }
  }

  function bind(root) {
    (root || d).querySelectorAll('[data-vf-clip]').forEach(function (f) {
      if (f._vfBound) return;
      f._vfBound = true;
      frames.push(f);
      var btn = f.querySelector('.vf-video__toggle');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var v = f.querySelector('video');
        if (v && v.getAttribute('src') && !v.paused) stop(f, false); else start(f);
      });
    });
  }

  function init() {
    bind(d);
    /* tapping Dr. Rajani's YouTube facade pauses any playing clip */
    d.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-vf-yt]')) pauseOthers(null);
    }, true);
    d.addEventListener('visibilitychange', function () { if (d.hidden) pauseOthers(null); });
    d.addEventListener('shopify:section:load', function (e) { frames = frames.filter(function (f) { return d.contains(f); }); bind(e.target); });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();

/* Free gift line: copies #VfGiftTpl above the main button of every stage buy box (hero, final). The gift itself is added
   to the cart in cartAdd() when cfg.giftId is set. */
(function () {
  'use strict';
  var d = document;
  function place(root) {
    var tpl = d.getElementById('VfGiftTpl');
    if (!tpl) return;
    (root || d).querySelectorAll('.vf-buy--stage').forEach(function (box) {
      if (box.querySelector('[data-vf-gift]')) return;
      var btn = box.querySelector(':scope > [data-vf-buy]');
      if (btn) box.insertBefore(tpl.content.cloneNode(true), btn);
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { place(); }); else place();
  d.addEventListener('shopify:section:load', function (e) { place(e.target); });
})();
